import { ClaimSteps } from './claim-steps.enum';

export function getRoute(step: ClaimSteps) {
  switch (step) {
    case ClaimSteps.CaptureModelNumber:
      return 'model-number';
    case ClaimSteps.FaultCapture:
      return 'fault-capture';
    case ClaimSteps.FaultStartDate:
      return 'fault-date';
    case ClaimSteps.AdditionalInfo:
      return 'additional-info';
    case ClaimSteps.ValidateDetails:
      return 'validate-details';
    case ClaimSteps.EngineerBooking:
      return 'engineer-booking';
    default:
      return 'model-number';
  }
}
